var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "announcement-list" },
    [
      _c("csp-table", {
        attrs: {
          icon: "inticon-autoclaim_document",
          "items-ajax-url": "/api/desktop/announcements",
          "table-headline": "Ankündigungen",
        },
        scopedSlots: _vm._u([
          {
            key: "above-body",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "py-2 text-right" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: "/de/Schaden-Manager/Dokument/announcements/create",
                        },
                      },
                      [
                        _c("b-button", { attrs: { variant: "primary" } }, [
                          _vm._v(
                            "\n                        Ankündigung anlegen\n                    "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }